import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { LegalContentService } from '../services/legal-content.service';
import { ConsentUiService } from '../services/consent-ui.service';
import { legalConfig } from '../config/legal-config';
import { SoundManifest, SoundManifestService } from '../services/sound-manifest.service';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-legal-page',
  templateUrl: './legal.page.html',
  styleUrls: ['./legal.page.scss'],
  standalone: false,
})
export class LegalPageComponent implements OnInit {
  title = 'Legal';
  content$: Observable<string> = of('');
  showCookiePreferences = false;
  showSoundCredits = false;
  showOperatorInfo = false;
  manifest$: Observable<SoundManifest | null> = of(null);
  config = legalConfig;

  constructor(
    private route: ActivatedRoute,
    private legalContent: LegalContentService,
    private consentUi: ConsentUiService,
    private soundManifest: SoundManifestService
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data;
    this.title = data['title'] ?? 'Legal';
    const markdownPath = data['markdown'] as string;
    this.showCookiePreferences = Boolean(data['showCookiePreferences']);
    this.showSoundCredits = Boolean(data['showSoundCredits']);
    this.showOperatorInfo = Boolean(data['showOperatorInfo']);

    if (markdownPath) {
      this.content$ = this.legalContent.loadMarkdown(markdownPath);
    }

    if (this.showSoundCredits) {
      this.manifest$ = this.soundManifest.loadManifest().pipe(
        catchError(() => of(null))
      );
    }
  }

  openCookiePreferences(): void {
    this.consentUi.openPreferences();
  }
}
